
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/pedidos.vue';
    import movil from './movil/pedidos.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {



    }
